import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getPermits, createPermits } from '../api/permission.api';
import { IPermit, IGetPermits, IPermitReq } from '../models/permission.model';

interface IPermitState {
  permits: IPermit[];
  isLoading: boolean;
  error?: AxiosError | string;
}

const initialState: IPermitState = {
  permits: [],
  isLoading: false,
};

const permitSlicer = createSlice({
  name: 'permit',
  initialState,
  reducers: {
    getPermitsStart: (state: IPermitState) => {
      state.permits = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getPermitsSuccess: (
      state: IPermitState,
      action: PayloadAction<IGetPermits>,
    ) => {
      state.permits = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getPermitsFailure: (
      state: IPermitState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.permits = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: IPermitState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (
      state: IPermitState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createSuccess: (state: IPermitState) => {
      state.isLoading = false;
      state.error = undefined;
    },
  },
});

export const {
  getPermitsStart,
  getPermitsSuccess,
  getPermitsFailure,
  requestStart,
  requestFailure,
  createSuccess,
} = permitSlicer.actions;

export default permitSlicer.reducer;

export const doGetPermits =
  (groupNo: number, menuCode: number): any =>
  async (dispatch: any) => {
    try {
      dispatch(getPermitsStart());
      const response = await getPermits(groupNo, menuCode);
      dispatch(getPermitsSuccess(response.data));
      return response;
    } catch (e: any) {
      dispatch(getPermitsFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };

export const doCreatePermits =
  (groupNo: number, menuCode: number, data: IPermitReq[]): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await createPermits(groupNo, menuCode, data);
      dispatch(createSuccess());
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response;
    }
  };
